
import _ from 'lodash';
import { mapState } from 'vuex';
import SocialMediaType from '@/enums/SocialMediaType';

export default {
  name: 'AppReviewOverlayInfoTotal',
  props: {
    review: {
      type: Object,
      required: true
    },
    video: {
      type: Object,
      default: null
    },
    videoUrl: {
      type: String,
      default: null
    },
    hideMediaCount: {
      type: Boolean,
      default: false
    },
    shape: {
      type: String,
      default: null,
      validator: v =>
        v === null || ['original', 'square', 'vertical'].includes(v)
    }
  },
  data() {
    return { iconSize: null, debouncedUpdateIconSize: null };
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    isSocialMediaType() {
      return this.review.social_media_type !== SocialMediaType.NONE;
    },
    showSocialMediaIcon() {
      if (!this.isSocialMediaType) return false;
      return ![SocialMediaType.FACEBOOK, SocialMediaType.VIMEO].includes(
        this.review.social_media_type
      );
    },
    showVideoPlayIcon() {
      if (this.showSocialMediaIcon) return false;
      if (!this.video) return false;
      return !this.reviewSettings.thumbnail_video_autoplay || !this.videoUrl;
    },
    showMediaCountIcon() {
      if (this.hideMediaCount) return false;
      if (this.showSocialMediaIcon) return false;
      if (this.showVideoPlayIcon) return false;
      return this.review.media_count > 1;
    }
  },
  mounted() {
    this.updateIconSize();
    this.debouncedUpdateIconSize = _.debounce(this.updateIconSize, 100);
    window.addEventListener('resize', this.debouncedUpdateIconSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedUpdateIconSize);
    if (this.debouncedUpdateIconSize) this.debouncedUpdateIconSize.cancel();
  },
  methods: {
    updateIconSize() {
      const containerIconSize = getComputedStyle(this.$el)
        .getPropertyValue('--icon-size')
        .trim();
      this.iconSize = containerIconSize
        ? parseInt(containerIconSize, 10)
        : null;
    }
  }
};
